"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = exports.warn = exports.log = void 0;
function log(...args) {
    if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        // tslint:disable-next-line
        console.log(...args);
    }
}
exports.log = log;
function warn(...args) {
    if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        // tslint:disable-next-line
        console.warn(...args);
    }
}
exports.warn = warn;
function error(...args) {
    if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        // tslint:disable-next-line
        console.error(...args);
    }
}
exports.error = error;
//# sourceMappingURL=logger.js.map